import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs/operators';

import { AuditRepository } from '@app/domain/repositories/audit/audit.repository.contract';
import { AuditMessage } from '@app/entities/models/audit/audit.model';
import { delayedRetry } from '@app/shared/utils/delayedRetry';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class AuditRepositoryImpl extends MRepository implements AuditRepository {
  constructor() {
    super(`${ENV.API_URL}`);
  }

  flush(auditMessages: AuditMessage[]) {
    const request = {
      body: auditMessages
    };

    return this.post('/audit', request).pipe(delayedRetry(3000), shareReplay());
  }
}
